import { includes, values } from 'lodash';

import { LanguageType } from '@jerry-serverless/enums/language_type';

export { LanguageType };

/**
 * Check if string value is in LanguageType enum
 * @param val
 */
export const isLanguageTypeEnumValue = (val?: string | null): val is LanguageType => {
  return includes(values(LanguageType), val);
};
